
import { Game } from "@/models/Game";
import { GoalsList } from "@/models/MapPois/Quest/Goals";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ActionBoxTabExit from "../ExitActions/ActionBoxTabExit.vue";

@Component({
  components: { ActionBoxTabExit },
})
class ActionBoxExit extends Vue {
  @Prop({ default: false }) readonly contentData!: GoalsList;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: false }) readonly showTextBox!: boolean;
  @Prop({ default: true }) readonly showText!: boolean;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: "" }) readonly mapPoiKey!: string;
  @Prop({ default: null }) readonly gameData!: Game;

  update(contentData: any): void {
    this.$emit("update", contentData);
  }
  deleteAction(contentData: any): void {
    this.$emit("deleteAction", contentData);
  }

  get getRequiredText(): string {
    if (this.required) {
      return "(REQUIRED)";
    }
    return " (OPTIONAL)";
  }
}

export default ActionBoxExit;
